import { StaticImageData } from 'next/image'
import IconCloud from './icon-cloud.svg'
import IconIntegration from './icon-integration.svg'

export type DifferencePointDataType = {
  icon: StaticImageData
  alt: string
  caption: string
  name: string
  columnTitle: string
  rowTitle: string
  description: string
  border: string
  status: boolean
}

export const differencePointData: DifferencePointDataType[] = [
  {
    icon: IconCloud,
    alt: 'iPaaS',
    caption: 'Number of Flows',
    name: 'iPaaS:',
    columnTitle: 'Number of Integration Scenarios',
    rowTitle: 'Number of external apps',
    description:
      'To implement 5 integration scenarios for 20 apps, you need to create 100 different flows in iPaaS',
    border: 'border__solid',
    status: false,
  },
  {
    icon: IconIntegration,
    alt: 'Integration App',
    caption: 'Number of Flows',
    name: 'Integration App:',
    columnTitle: 'Number of Integration Scenarios',
    rowTitle: 'Number of external apps',
    description:
      'To implement 5 scenarios for 20 apps, you need to create just 5 universal flows in integration App',
    border: 'border__gradient',
    status: true,
  },
]
